<template>
    <div class="exam-result-management">
        <h3>시스템 설정 > 장비 관리</h3>
        <!-- 검색/필터 영역 -->
        <div class="account-card-box">
            <div class="erm-search-controls">
                <div>
                    <label class="erm-label" for="connStatus">연결 상태</label>
                    <select v-model="connStatus" class="erm-select-con">
                        <option value="">전체</option>
                        <option value="0">연결됨</option>
                        <option value="1">신호 없음</option>
                    </select>
                </div>
                <div>
                    <select v-model="equipment" class="erm-select">
                        <option value="equipmentName">장비명</option>
                        <option value="serialNumber">시리얼 번호</option>
                    </select>
                    <input class="erm-search-input" type="text" v-model="keyword" placeholder="검색어 입력" maxlength="100" />
                </div>
                <div>
                    <button class="erm-search-btn" @click="search()">검색</button>
                </div>
            </div>
        </div>

        <div>
            <!-- 기기 추가/삭제 버튼 -->
            <div class="erm-action-btns">
                <button class="erm-btn-del" @click="deleteDevice">기기 삭제</button>
                <button class="erm-btn-add" @click="addDevice">기기 추가</button>
            </div>
            <div class="erm-search-row">
                <div class="list-sort">
                    <select v-model="sortOption" class="sortOption">
                        <option value="list">목록 정렬</option>
                        <option value="deviceName">장비명</option>
                        <option value="serialNumber">시리얼 번호</option>
                        <option value="connectionStatus">연결상태</option>
                        <option value="firmwareVersion">펌웨어</option>
                    </select>
                </div>
            </div>
        </div>


        <!-- 장비 목록 테이블 -->
        <div class="erm-table-container">
            <table class="erm-device-table">
                <thead>
                <tr>
                    <th style="width: 40px"><input type="checkbox" :checked="selectAll" @change="toggleAll" /></th>
                    <th>장비명</th>
                    <th>시리얼 번호</th>
                    <th>연결 상태</th>
                    <th>펌웨어</th>
                    <th>상세 보기</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="device in pagedDeviceList" :key="device.id">
                    <td>
                        <input type="checkbox" v-model="selectedIds" :value="device.id"/>
                    </td>
                    <td>{{ device.device_name }}</td>
                    <td>{{ device.serial_number }}</td>
                    <td>
                    <span
                        class="status-dot"
                        :class="device.status === '0' ? 'connected' : (device.status === '1' ? 'disconnected' : '')"></span>
                        {{ device.status === '0' ? '연결됨' : (device.status === '1' ? '신호 없음' : '알 수 없음') }}
                    </td>
                    <td>{{ device.firmware_version }}</td>
                    <td><a href="#" class="erm-table-link" @click.prevent="viewDevice(device)">상세 보기</a></td>
                    <td><span v-if="device.update_needed" class="erm-update-needed">업데이트 필요</span></td>
                </tr>
                <tr v-if="devices.length === 0">
                    <td colspan="7" style="text-align:center; color:#aaa; padding: 28px;">데이터가 없습니다.</td>
                </tr>
                </tbody>
            </table>
        </div>
        <pagination
            :total-items="totalCount"
            :page-size="pageSize"
            v-model="currentPage"
            @page-change="onPageChange"
        />
    </div>
</template>

<script>
import Pagination from "@/components/common/Pagination.vue";
import api, {urls} from "@/api";


export default {
    components: {Pagination},
    data() {
        return {
            devices: [],         // 장비 리스트
            connStatus: '',      // 연결 상태 필터값 ('0'= 성공, '1'- 실패)
            equipment: 'equipmentName', // 검색 조건(장비명 or 시리얼번호)
            keyword: '',         // 검색어
            sortOption: 'list',  // 정렬 조건
            selectAll: false,     // 전체 선택 여부

            currentPage: 1,       // 현재 페이지 번호
            pageSize: 10,         // 한 페이지에 보여줄 개수 (필요에 따라 변경 가능)
            totalPages: 1,        // 총 페이지 수 (백엔드에서 받아옴)
            totalCount: 0,        // 총 데이터 개수 (옵션, 백엔드에서 받아옴)
            isLoading: false
        };
    },

    computed: {
        pagedDeviceList() {
            // 정렬할 복사본 생성 (원본 this.devices 직접 변경은 피함)
            let sortedDevices = [...this.devices];

            switch(this.sortOption) {
                case 'deviceName':
                    sortedDevices.sort((a, b) => a.device_name.localeCompare(b.device_name));
                    break;
                case 'serialNumber':
                    sortedDevices.sort((a, b) => a.serial_number.localeCompare(b.serial_number));
                    break;
                case 'connectionStatus':
                    // 상태 숫자 혹은 문자열 형태에 맞게 정렬
                    sortedDevices.sort((a, b) => {
                        // 빈값 보호 및 숫자 변환 시도
                        const statusA = a.status !== undefined ? String(a.status) : '';
                        const statusB = b.status !== undefined ? String(b.status) : '';
                        return statusA.localeCompare(statusB);
                    });
                    break;
                case 'firmwareVersion':
                    sortedDevices.sort((a, b) => a.firmware_version.localeCompare(b.firmware_version));
                    break;
                case 'list':
                default:
                    // 기본 정렬(예: id 순서)
                    sortedDevices.sort((a, b) => (a.id || 0) - (b.id || 0));
            }

            // 페이지네이션 처리
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;

            return sortedDevices.slice(start, end);
        }
    },

    methods: {
        onPageChange(page) {
            this.currentPage = page;   // 현재 페이지 갱신
        },
        // 계정 목록
        getlist(page = 1) {
            api.get(urls.system.deviceList)
                .then(res => {
                    const resInfo = res.data;
                    this.devices = resInfo.list || [];
                    this.totalCount = res.data.totalCount || this.devices.length;
                    this.totalPages = Math.ceil(this.totalCount / this.pageSize);
                    this.currentPage = page;
                    this.selectedIds = [];
                    this.selectAll = false;
                })
                .catch(err => {
                    alert("장비 목록 조회 실패");
                    this.devices = [];
                    this.totalCount = 0;
                    this.selectedIds = [];
                    this.selectAll = false;
                    console.error(err);
                });
        },

        search(page = 1) {
            const payload = {};
            if (this.connStatus) {
                if (this.connStatus === 'connected') {
                    payload.status = 0;
                } else if (this.connStatus === 'disconnected') {
                    payload.status = 1;
                } else {
                    payload.status = this.connStatus;
                }
            }

            if (this.keyword && this.keyword.trim() !== '' && this.equipment) {
                payload[this.equipment] = this.keyword.trim();
            }

            api.post(urls.system.deviceSearch, payload)
                .then(res => {
                    this.devices = (res.data.list || []).map(device => ({
                        id: device.id,
                        device_name: device.deviceName || device.device_name || '',
                        serial_number: device.serialNumber || device.serial_number || '',
                        status: device.status !== undefined ? device.status : '',
                        firmware_version: device.firmwareVersion || device.firmware_version || '',
                        update_needed: device.updateNeeded !== undefined ? device.updateNeeded : device.update_needed || false,
                        model_name: device.modelName || device.model_name || '',
                        last_fw_update: device.lastFwUpdate || device.last_fw_update || null,
                        registered_at: device.registeredAt || device.registered_at || null,
                        updated_at: device.updatedAt || device.updated_at || null,
                    }));

                    this.totalCount = res.data.totalCount || this.devices.length;
                    this.totalPages = Math.ceil(this.totalCount / this.pageSize);
                    this.currentPage = page;
                    this.selectedIds = [];
                    this.selectAll = false;
                })
                .catch(error => {
                    this.error = '장비 검색 기능이 실패했습니다.';
                    alert(this.error);
                    this.devices = [];
                    this.selectedIds = [];
                    this.selectAll = false;
                    this.totalCount = 0;
                    this.totalPages = 1;
                    console.error(error);
                });
        },

        deleteDevice() {
            if (this.selectedIds.length === 0) {
                alert("삭제할 대상을 선택하세요.");
                return;
            }
            api.post(urls.system.deviceDelete, { idList: this.selectedIds })
                .then(res => {
                    const resInfo = res.data;
                    if (resInfo === 1) {
                        alert('장비 삭제에 성공했습니다.');
                        this.getlist();
                    } else {
                        this.error = resInfo.message || '장비 삭제에 실패하였습니다.';
                        alert(this.error);
                    }
                })
                .catch(error => {
                    this.error = '장비 삭제기능이 실패했습니다.';
                    alert(this.error);
                    this.getlist();
                });
        },

        // 전체선택/해제
        toggleAll(event) {
            this.selectAll = event.target.checked;
            if (this.selectAll) {
                this.selectedIds = this.devices.map((acc) => acc.id);
            } else {
                this.selectedIds = [];
            }
        },

        addDevice() {
            this.$router.push({ name: 'DeviceDetails' });
        },

        viewDevice(device) {
            this.$router.push({
                name: 'DeviceDetails',
                query: { id: device.id }
            });
        },

    },
    mounted() {
        this.getlist();
    },
};
</script>

